
import React from "react";
import { SvgIcon, SvgIconProps } from '@mui/material';

const InfoIcon= (props: SvgIconProps) => {
	const { htmlColor } = props
	return <SvgIcon {...props} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="34" height="34" rx="6" fill={htmlColor}/>
		<g clip-path="url(#clip0_560_190)">
			<path d="M17.0001 8.50625C12.3032 8.50625 8.50635 12.3031 8.50635 17C8.50635 21.6969 12.3032 25.5219
			17.0001 25.5219C21.697 25.5219 25.522 21.6969 25.522 17C25.522 12.3031 21.697 8.50625 17.0001
			8.50625ZM17.0001 24.2563C13.0063 24.2563 9.77197 20.9938 9.77197 17C9.77197 13.0063 13.0063
			9.77188 17.0001 9.77188C20.9938 9.77188 24.2563 13.0344 24.2563 17.0281C24.2563 20.9938 20.9938
			24.2563 17.0001 24.2563Z" fill="white"/>
			<path d="M18.1249 15.65H15.8749C15.5374 15.65 15.228 15.9313 15.228 16.2969V21.9219C15.228 22.2594
			15.5093 22.5688 15.8749 22.5688H18.1249C18.4624 22.5688 18.7718 22.2875 18.7718 21.9219V16.2969C18.7718
			15.9313 18.4624 15.65 18.1249 15.65ZM17.5062 21.275H16.5218V16.9156H17.5062V21.275Z" fill="white"/>
			<path d="M16.9999 11.4594C16.0437 11.4594 15.228 12.2469 15.228 13.2313C15.228 14.2156 16.0155 15.0031
			16.9999 15.0031C17.9843 15.0031 18.7718 14.2156 18.7718 13.2313C18.7718 12.2469 17.9562 11.4594 16.9999
			11.4594ZM16.9999 13.7094C16.7187 13.7094 16.4937 13.4844 16.4937 13.2031C16.4937 12.9219 16.7187 12.6969
			16.9999 12.6969C17.2812 12.6969 17.5062 12.9219 17.5062 13.2031C17.5062 13.4844 17.2812 13.7094 16.9999
			13.7094Z" fill="white"/>
		</g>
		<defs>
			<clipPath id="clip0_560_190">
				<rect width="18" height="18" fill="white" transform="translate(8 8)"/>
			</clipPath>
		</defs>
	</SvgIcon>
}

export default InfoIcon;
